import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const EditMemberDialog = ({ member, onClose, onSaved }) => {
  const [name, setName] = useState(member.name);
  const [email, setEmail] = useState(member.email);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put(`/admin/members/${member.id}`, { name: name.trim(), email: email.trim() });
      toast.success(`Updated ${name.trim()}`);
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="admin-edit-member-dialog" className="bg-[#1B2A41] text-[#F8FAFC] border-[#2C3E55]">
        <DialogHeader>
          <DialogTitle className="font-type">Edit member</DialogTitle>
          <DialogDescription className="text-[#F8FAFC]/60">{member.member_number} · {member.electorate} ({member.state}). Change the email to switch a member to a working address, then re-send their welcome email.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="font-type text-[11px] uppercase tracking-wider text-[#8FA58A]">Name</Label>
            <Input data-testid="admin-edit-member-name" required minLength={2} value={name} onChange={(e) => setName(e.target.value)} className="h-10 bg-[#121E2B] border-[#2C3E55]" />
          </div>
          <div className="space-y-1.5">
            <Label className="font-type text-[11px] uppercase tracking-wider text-[#8FA58A]">Email</Label>
            <Input data-testid="admin-edit-member-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-10 bg-[#121E2B] border-[#2C3E55]" />
          </div>
          <button type="submit" disabled={busy} data-testid="admin-edit-member-save" className="w-full h-10 rounded-full bg-[#E2705A] hover:bg-[#D35D46] disabled:opacity-60 font-type font-bold uppercase tracking-wider text-xs inline-flex items-center justify-center gap-2">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Save changes
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
